import React from 'react';
import VATAdd from './VATAdd';

const VATDetail = () => {
  return <VATAdd />;
};

export default VATDetail;
